export default "__VITE_ASSET__4416eb63__"